import { render, staticRenderFns } from "./Alarm.vue?vue&type=template&id=2d42bc64&scoped=true"
import script from "./Alarm.vue?vue&type=script&lang=ts"
export * from "./Alarm.vue?vue&type=script&lang=ts"
import style0 from "./Alarm.vue?vue&type=style&index=0&id=2d42bc64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d42bc64",
  null
  
)

export default component.exports